import { defineComponent as _defineComponent } from 'vue'
import { check_user_auth_status } from './module/auth/module.ts';
    import { nextTick, onMounted, ref } from "vue";

    
export default /*@__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props, { expose: __expose }) {
  __expose();

    let loading = ref(true)
    
    async function start_check_user_auth_status_loop() {
        let loc_is_authed = false

        try {
            loc_is_authed = await check_user_auth_status()
        } catch (error) {
            console.error("Error checking user auth status", error)
        }
        
        setTimeout(() => {
            start_check_user_auth_status_loop()
        }, 15000)

        return loc_is_authed
    }

    onMounted(async () => {
        const is_authed = await start_check_user_auth_status_loop()

        nextTick(() => {
            loading.value = false
        })
    })

    


const __returned__ = { get loading() { return loading }, set loading(v) { loading = v }, start_check_user_auth_status_loop }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})